import { render } from "./EcpReporte.vue?vue&type=template&id=bf881aea&scoped=true"
import script from "./EcpReporte.vue?vue&type=script&lang=js"
export * from "./EcpReporte.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EcpReporte.vue?vue&type=style&index=1&id=bf881aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf881aea"]])

export default __exports__